export { default } from './RenderSpot';
